import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orders: [], // array to store placed orders
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    addOrder: (state, action) => {
      // action.payload = { items, total, userDetails, orderDate, id }
      state.orders.push(action.payload);
    },
    clearOrders: (state) => {
      state.orders = [];
    },
  },
});

export const { addOrder, clearOrders } = ordersSlice.actions;
export default ordersSlice.reducer;
